module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"language":"Language","accountmanagement":"Account management","manage":"Manage"},"fr":{"language":"Langue","accountmanagement":"Gérer son profil utilisateur","manage":"Gérer"}}')
  delete Component.options._Ctor
}
